const blockCustomField = [
    {
        field_name: 'countryMasterId',
        label: 'Country',
        type: "string",
        isRequired: true
    },
    {
        field_name: 'stateMasterId',
        label: 'State',
        type: "string",
        isRequired: true
    },
    {
        field_name: 'name',
        label: 'Block',
        type: "string",
        isRequired: true,
        // removeSpecialCharacter: true,
    },
    {
        field_name: 'status',
        label: 'Status',
        type: "string",
        isRequired: true
    },
    {
        field_name: 'e_p_regime',
        label: 'E&P Regime',
        type: "string",
        isRequired: true
    },
    {
        field_name: 'agreement_date',
        label: 'Agreement Date',
        type: "string",
        isRequired: true
    }
];



export const Constant = {
    blockCustomField
}
